"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    decoders: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_DECODERS,
        onSuccess: function (draftState, action) {
            var _a, _b;
            // eslint-disable-next-line no-param-reassign
            draftState.data = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.decoders;
        },
    })), api_1.createApiInitialState([])),
    record: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.RECORD,
    })), (_a = {}, _a[constants_1.RESET_REMOTE_RECORD] = function (draftState) {
        draftState.data = null;
        draftState.error = null;
    }, _a)), api_1.createApiInitialState(null)),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map